import React, { Component } from 'react';
import { food } from '../../lib/api';
import Loading from '../common/Loading';
import Page from '../common/Page';
import PageTable from '../common/PageTable';
import ExpiredWall from "../ExpiredWall";

class FoodList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            food: null,
            loading: true,
            panel: 'composicao',
            source: 'todos'
        };

        this.refresh = this.refresh.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onClone = this.onClone.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.onPanelChange = this.onPanelChange.bind(this);
        this.onSourceChange = this.onSourceChange.bind(this);
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        food.list()
            .then(food => this.setState({
                food: food,
                loading: false
            }))
            .catch(error => this.setState({
                food: null,
                loading: true
            }));
    }

    onAdd(id) {
        this.props.history.push(`/alimentos/adicionar`);
    }

    onEdit(id) {
        this.props.history.push(`/alimentos/${id}/editar`);
    }

    onClone(id) {
        food.clone(id)
            .then(json => {
                this.refresh();
            })
            .catch(error => {
                console.log(error);
            });
    }

    onDelete(id, row) {
        if (!window.confirm(`Deseja mesmo apagar o alimento "${row.name}"?`)) {
            return;
        }

        food.remove(id)
            .then(json => {
                this.refresh();
            })
            .catch(error => {
                console.log(error);
            });
    }

    onRowClick(id) {
        this.props.history.push(`/alimentos/${id}`);
    }

    onPanelChange(id) {
        this.setState({
            panel: id
        });
    }

    onSourceChange(id) {
        this.setState({
            source: id
        });
    }

    render() {
        if (this.props.user.plan === 'EXPIRED') {
            return <ExpiredWall />;
        }

        if (this.state.loading) {
            return (
                <Page title="Alimentos">
                    <Loading />
                </Page>
            );
        }

        const numberFormatter = (value, decimals, unit) => {
            if (value) {
                return `${value.toFixed(decimals)} ${unit}`;
            } else {
                return `${(0).toFixed(decimals)} ${unit}`;
            }
        }

        const kcalFormatter = (value) => numberFormatter(value, 0, "kcal");
        const gFormatter = (value) => numberFormatter(value, 1, "g");
        const mgFormatter = (value) => numberFormatter(value, 0, "mg");
        const mg2Formatter = (value) => numberFormatter(value, 2, "mg");
        const µgFormatter = (value) => numberFormatter(value, 1, "µg");

        const column = (key, title, abbreviation, formatter) => ({
            key: key,
            title: title,
            abbreviation: abbreviation,
            searchable: false,
            sortable: true,
            headerClassName: "is-nowrap is-unselectable has-text-right is-hidden-mobile",
            rowClassName: "is-nowrap is-fit has-text-right is-hidden-mobile",
            formatter: formatter
        });

        const panels = [
            { id: "composicao", name: "Composição", columns: [
                column("energia_kcal",          "Energia",             null,       kcalFormatter),
                column("lipidos_g",             "Lípidos",             null,       gFormatter),
                column("hidratos_de_carbono_g", "Hidratos de Carbono", "Hidratos", gFormatter),
                column("fibra_g",               "Fibra",               null,       gFormatter),
                column("proteinas_g",           "Proteínas",           null,       gFormatter),
                column("sal_g",                 "Sal",                 null,       gFormatter),
                column("alcool_g",              "Álcool",              null,       gFormatter),
                column("agua_g",                "Água",                null,       gFormatter),
                column("acidos_organicos_g",    "Ácidos Orgânicos",    "Ácidos",   gFormatter),
                column("colesterol_mg",         "Colesterol",          null,       mgFormatter)
            ]},
            { id: "lipidos", name: "Lípidos", columns: [
                column("acidos_gordos_saturados_g",       "Ácidos gordos saturados",       "Saturados",       gFormatter),
                column("acidos_gordos_monoinsaturados_g", "Ácidos gordos monoinsaturados", "Monoinsaturados", gFormatter),
                column("acidos_gordos_polinsaturados_g",  "Ácidos gordos polinsaturados",  "Polinsaturados",  gFormatter),
                column("acido_linoleico_g",               "Ácido linoleico",               "Linoleico",       gFormatter),
                column("acidos_gordos_trans_g",           "Ácidos gordos trans",           "Trans",           gFormatter)
            ]},
            { id: "hidratos", name: "Hidratos de Carbono", columns: [
                column("acucares_g",        "Açúcares",        null, gFormatter),
                column("oligossacaridos_g", "Oligossacáridos", null, gFormatter),
                column("amido_g",           "Amido",           null, gFormatter)
            ]},
            { id: "vitaminas", name: "Vitaminas", columns: [
                column("vitamina_a_µg",              "Vitamina A",              "Vit. A",      µgFormatter),
                column("vitamina_d_µg",              "Vitamina D",              "Vit. D",      µgFormatter),
                column("alfa_tocoferol_mg",          "α-tocoferol",             null,          mg2Formatter),
                column("tiamina_mg",                 "Tiamina",                 null,          mg2Formatter),
                column("riboflavina_mg",             "Riboflavina",             null,          mg2Formatter),
                column("niacina_mg",                 "Niacina",                 null,          mg2Formatter),
                column("equivalentes_de_niacina_mg", "Equivalentes de niacina", "Eq. niacina", mg2Formatter),
                column("triptofano_60_mg",           "Triptofano/60",           null,          mg2Formatter),
                column("vitamina_b6_mg",             "Vitamina B6",             "Vit. B6",     mg2Formatter),
                column("vitamina_b12_µg",            "Vitamina B12",            "Vit. B12",    µgFormatter),
                column("vitamina_c_mg",              "Vitamina C",              "Vit. C",      mg2Formatter),
                column("folatos_µg",                 "Folatos",                 null,          µgFormatter)
            ]},
            { id: "carotenoides", name: "Carotenoides", columns: [
                column("equivalentes_de_beta_caroteno_µg", "Equivalentes de β-caroteno", "Eq. β-caroteno", µgFormatter),
                column("alfa_caroteno_µg",                 "α-caroteno",                 null,             µgFormatter),
                column("beta_caroteno_total_µg",           "β-caroteno total",           null,             µgFormatter),
                column("beta_criptoxantina_µg",            "β-criptoxantina",            null,             µgFormatter),
                column("licopeno_µg",                      "Licopeno",                   null,             µgFormatter),
                column("luteina_µg",                       "Luteína",                    null,             µgFormatter),
                column("zeaxantina_µg",                    "Zeaxantina",                 null,             µgFormatter)
            ]},
            { id: "minerais", name: "Minerais", columns: [
                column("cinza_g",     "Cinza",    null, gFormatter),
                column("sodio_mg",    "Sódio",    null, mgFormatter),
                column("potassio_mg", "Potássio", null, mgFormatter),
                column("calcio_mg",   "Cálcio",   null, mgFormatter),
                column("fosforo_mg",  "Fósforo",  null, mgFormatter),
                column("magnesio_mg", "Magnésio", null, mgFormatter),
                column("ferro_mg",    "Ferro",    null, mg2Formatter),
                column("zinco_mg",    "Zinco",    null, mg2Formatter),
                column("selenio_µg",  "Selénio",  null, µgFormatter),
                column("iodo_µg",     "Iodo",     null, µgFormatter)
            ]}
        ];

        const panel = panels.find(panel => panel.id === this.state.panel);

        const columns = [
            { key: "name", title: "Nome", abbreviation: null, searchable: true, sortable: true, headerClassName: "is-nowrap is-unselectable has-text-left", rowClassName: "ellipsis" },
            ...panel.columns
        ];

        const sources = [
            { id: "todos",          name: "Todos",          filter: (row) => true },
            { id: "insa",           name: "INSA",           filter: (row) => !row.user_id },
            { id: "personalizados", name: "Personalizados", filter: (row) => !!row.user_id }
        ];

        const source = sources.find(source => source.id === this.state.source);

        const rows = this.state.food.filter(source.filter);

        const toolbar = (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem' }}>
                <div className="buttons are-small mb-0 is-hidden-mobile">
                    { panels.map(panel =>
                        <button
                            key={panel.id}
                            className={`button is-rounded ${this.state.panel === panel.id ? 'is-primary' : 'is-light'}`}
                            onClick={(ev) => this.onPanelChange(panel.id)}>
                            {panel.name}
                        </button>
                    )}
                </div>
                <div className="buttons are-small has-addons mb-0" style={{ flexWrap: 'nowrap' }}>
                    { sources.map(source =>
                        <button
                            key={source.id}
                            className={`button ${this.state.source === source.id ? 'is-primary is-selected' : ''}`}
                            onClick={(ev) => this.onSourceChange(source.id)}>
                            {source.name}
                        </button>
                    )}
                </div>
            </div>
        );

        const actions = (
            <div className="buttons is-right">
                <button title="Adicionar Alimento" className="button is-light is-primary" onClick={this.onAdd}>
                    <span className="icon">
                        <i className="fas fa-plus"></i>
                    </span>
                    <span>Adicionar</span>
                </button>
            </div>
        );

        const inlineActions = (value, row) => {
            const owner = !!row.user_id;

            return (
                <div className="buttons is-right">
                    <button title="Editar" className="button is-small is-light is-info" onClick={() => this.onEdit(value, row)} disabled={!owner}>
                            <span className="icon is-small">
                                <i className="fas fa-pencil-alt"></i>
                            </span>
                    </button>
                    <button title="Duplicar" className="button is-small is-light is-info" onClick={() => this.onClone(value, row)}>
                            <span className="icon is-small">
                                <i className="fas fa-copy"></i>
                            </span>
                    </button>
                    <button title="Apagar" className="button is-small is-light is-danger" onClick={() => this.onDelete(value, row)} disabled={!owner}>
                            <span className="icon is-small">
                                <i className="far fa-trash-alt"></i>
                            </span>
                    </button>
                </div>
            );
        };

        return (
            <PageTable
                title="Alimentos"
                className="is-hoverable"
                columns={columns}
                toolbar={toolbar}
                rows={rows}
                actions={actions}
                inlineActions={inlineActions}
                onRowClick={this.onRowClick}
                orderBy="name"
                orderAscending={true}
            />
        );
    }
}

export default FoodList;
